import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { APP_CONFIG, Env } from '../../environment';
import { HttpProvider } from '../http/http';
import { LoggerProvider } from '../logger/logger';

@Injectable()
export class ConfigProvider {
  static settings = {
    logCheckTimerMs: 1000,
    logSendTimerMs: 10000,
    logErrorTimerMs: 60000,
    logFailedSends: 1000,
    logMaxSize: 1000,
    logWhiteList: '',
    logBlackList: '',
    logMinimumLevel: 'Trace',
    configTimerMs: 60000,
    connectionTimeout: APP_CONFIG.connectionTimeoutSettings.requestTimeoutThreshold,
    reconnectTimeoutMs: 4000,
    loadingTimeoutMs: APP_CONFIG.loadingTimeoutMs,
    reloadActivity: 30000,
    keychainKey: 'store',
    onfidoTimeout: 60000,
    onfidoCheckTimer: 5000,
    inAppNotificationTimer: 120000,
    refreshGraceSeconds: 45000,
    trackNetworkEvents: true,
    orderConnectionTimeout: 60
  };
  static lastReceived;
  
  static async startConfig(httpProvider: HttpProvider, platform: Platform) {    
    if (!ConfigProvider.lastReceived && !platform.is('cordova') && APP_CONFIG.env !== Env.PROD)
      ConfigProvider.settings.logMinimumLevel = 'Debug';

    if (!APP_CONFIG.phpApiBaseUrl)
      return; 
      
    try {
      const payload = {
        settings: ConfigProvider.settings,
        user: LoggerProvider.user,
        deviceid: LoggerProvider.uuid,
        sessionId: LoggerProvider.sessionId,
        parentSessionId: LoggerProvider.parentSessionId,
        appVersion: LoggerProvider.appVersion,
        appInfo: LoggerProvider.appInfo
      };
      await httpProvider.postExtern(`${APP_CONFIG.phpApiBaseUrl}config.php`, payload, {}, 'json', (res) => {
        ConfigProvider.lastReceived = new Date();
        if (res.settings) {
          ConfigProvider.settings = { ...ConfigProvider.settings, ...res.settings };

        }
      });
    }
    catch (ex) {
      LoggerProvider.trace(this, 'Failed to get configuration in configuration provider', ex);
    }
    window.setTimeout(() => {
      this.startConfig(httpProvider, platform);
    }, ConfigProvider.settings.configTimerMs);
  }
}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts